export default "__VITE_ASSET__VHOudYh3__"